module.exports = __webpack_public_path__ + "progress-5f03b0c0d16d86747d95a17dec1ab340.png";